import { useEffect, useRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const GOOGLE_TAG_MANAGER_ID = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;

export function GoogleTagManagerHead() {
  const initRef = useRef(false);
  useEffect(() => {
    if (!GOOGLE_TAG_MANAGER_ID || typeof window === "undefined") return;

    // Prevent duplicate GTM initialization
    if (initRef.current) {
      return;
    }

    // Inject GTM script client-side only
    const script = document.createElement("script");
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');`;
    document.head.insertBefore(script, document.head.firstChild);
    initRef.current = true;
  }, []);
  // Return null to avoid hydration mismatch - script is injected via useEffect
  return null;
}


export function GoogleTagManagerBody() {
  useEffect(() => {
    if (!GOOGLE_TAG_MANAGER_ID || typeof window === "undefined") return;

    // Prevent duplicate GTM noscript injection
    if (document.querySelector('noscript iframe[src*="googletagmanager.com/ns.html"]')) return;

    // Inject noscript iframe client-side only
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER_ID}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    iframe.title = "google-tag-manager";
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);

  // Return null to avoid hydration mismatch - noscript is injected via useEffect
  return null;
}
